<template>
  <component :is="menus[data.menu]" :units="units" :has-meta="data.hasMeta"></component>
</template>
<script setup>
/* eslint-disable quote-props */
import groupBy from 'lodash/groupBy';
import first from 'lodash/first';

import { TYPE } from '@/constants';

import DefaultMenu from './default.vue';
import PredefinedMenu from './predefined.vue';
import SeatsMenu from './seats.vue';
import SMTableContextmenu from './SMTableContextmenu.vue';
import ShapesMenu from './shapes.vue';
import TextsMenu from './texts.vue';
import SectionMenu from './section.vue';
import SectionsMenu from './sections.vue';
import { reactive, shallowRef } from 'vue';
import GAMenu from './GAMenu.vue';

const props = defineProps({
  selection: Object,
});

const menus = {
  default: DefaultMenu,
  [TYPE.PREDEFINED]: PredefinedMenu,
  [TYPE.SEAT]: SeatsMenu,
  [TYPE.SHAPE]: ShapesMenu,
  [`${TYPE.TABLE}s`]: SMTableContextmenu,
  [`${TYPE.TEXT}s`]: TextsMenu,
  [TYPE.GA]: GAMenu,
  [`${TYPE.SECTION}s`]: SectionMenu,
  [`${TYPE.SECTION}ss`]: SectionsMenu,
};

const data = reactive({
  menu: 'default',
  hasMeta: false,
  units: null,
  position: {
    top: '',
    left: '',
  },
});

const units = shallowRef(null);

const setContextMenu = () => {
  groupSelectionByType();
};

const isManyUnits = (keys, groups) => {
  return keys.length === 1 && keys[0] !== TYPE.SEAT && groups[keys[0]].length > 1;
};

const groupSelectionByType = () => {
  const grouped = groupBy(props.selection.items, 'type');
  const keys = Object.keys(grouped);
  const type = first(keys);

  if (keys.length === 1 && keys[0] === TYPE.SECTION && grouped[type].length > 1) {
    data.menu = `${TYPE.SECTION}ss`;
    units.value = grouped[type];
    return;
  }

  if (keys.length > 1 || isManyUnits(keys, grouped)) {
    data.menu = 'default';
    data.hasMeta = keys.length === 1 && keys[0] === TYPE.TABLE;
  } else {
    // because it casts to 'table' which is html element so changing a bit
    if ([TYPE.TABLE, TYPE.TEXT, TYPE.SECTION].indexOf(type) !== -1) {
      data.menu = `${type}s`;
    } else {
      data.menu = type;
    }
  }
  units.value = grouped[type];
};

setContextMenu();
</script>
<style lang="scss">
.md-avatar {
  border-radius: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 66%;
    height: 66%;
  }
}

.vue-color__chrome {
  margin: 6px 8px;
  width: auto !important;
}
</style>
